module.exports = __webpack_public_path__ + "img/aetosky_logo.416add0c.jpg";